import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const SettingsNavigationContext = createContext({});

export const SettingsNavigationContextProvider = ({ children }) => {
    const [defaultOptionRoute, setDefaultOptionRoute] = useState('');
    const [previousRoute, setPreviousRoute] = useState('');
    const [returnToPrevious, setReturnToPrevious] = useState(false);
    const [initRoute, setInitRoute] = useState('');

    return (
        <SettingsNavigationContext.Provider
            value={{
                defaultOptionRoute,
                setDefaultOptionRoute,
                previousRoute,
                setPreviousRoute,
                returnToPrevious,
                setReturnToPrevious,
                initRoute,
                setInitRoute
            }}
        >
            {children}
        </SettingsNavigationContext.Provider>
    );
};

SettingsNavigationContextProvider.defaultProps = {
    children: []
};

SettingsNavigationContextProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const useSettingsNavigation = () => useContext(SettingsNavigationContext);

export const withSettingsNavigation = (Component) => (props) => (
    <SettingsNavigationContext.Consumer>
        {(context) => <Component {...props} {...context} />}
    </SettingsNavigationContext.Consumer>
);
